<template><div /></template>

<script>
export default {
  name: 'Privacy',
}
</script>

<style scoped></style>
